module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_8019.b2a883ba.png";